import * as InsuranceRteRequest from './models/insuranceRteRequest';
import { Common } from './common';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(
    query?: InsuranceRteRequest.FindAllOptions,
  ): Promise<InsuranceRteRequest.InsuranceRteRequest[]> {
    const url = this.common.constructPath('/insurance-rte-requests', query);
    return this.common.getJSON(url);
  }
}
